export default __webpack_public_path__ + "assets/images/3a0bb3aa9a95fc2290abdf1d82359918.svg";